export const PATH = {
    LANDINGPAGE: '/',
    PLANNINGPAGE: '/planning',
    MANAGETEAM: '/manage-team',
    SCHEDULEPAGE: '/schedule'
}